import React, { createContext, useState, useContext, useEffect } from "react";

const StateContext = createContext();
const initialState = {
  listing: {
    weightList: [],
  },
};
export const StateDataProvider = ({ children }) => {
  const [appData, setAppData] = useState(initialState);

  return (
    <StateContext.Provider value={{ appData, setAppData }}>
      {children}
    </StateContext.Provider>
  );
};

export const useData = () => useContext(StateContext);
